module.exports = __webpack_public_path__ + "img/tips4.38bfb1c6.png";